module.exports = __webpack_public_path__ + "static/media/messenger.b4e2da1f.png";